var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { InsuranceProducts, UserIntent } from "../constants";
import AppBody from "../components/AppBody";
import Header from "../components/Header";
import Image from "../components/Image";
import { PHASE } from "../routeConfig";
import RouteHeaderLogo from "../components/RouteHeaderLogo";
import RouteTitle from "../components/RouteTitle";
import { selectUserIntent } from "../features/applicant/applicantSlice";
import { selectedUserIntent } from "../lib/Avo";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import { useHistory } from "react-router-dom";
var userIntentionOptions = [
    {
        key: UserIntent.BETTER_RATE,
        label: "Looking for a better rate",
        icon: "assets/icons/piggy-bank-icon.png",
    },
    {
        key: UserIntent.NEW_AUTO_POLICY,
        label: "Need insurance for a new car",
        icon: "assets/icons/car-front-icon.png",
    },
    {
        key: UserIntent.BETTER_COVERAGE,
        label: "Looking for better coverage",
        icon: "assets/icons/shield-looking-glass-icon.png",
    },
    {
        key: UserIntent.BROWSE,
        label: "Just browsing",
        icon: "assets/icons/eye-icon.png",
    },
];
function IntentionOption(_a) {
    var label = _a.label, icon = _a.icon, onClick = _a.onClick;
    return (React.createElement("button", { id: "product-".concat(label.toString()), "data-cy": "product-".concat(label.toString()), className: "block cursor-pointer overflow-hidden rounded-lg border border-gray-200 px-4 py-8 transition-all duration-200 hover:opacity-75", onClick: onClick },
        React.createElement("div", { className: "flex items-center justify-center" },
            React.createElement("div", { className: "flex flex-col items-center justify-center" },
                React.createElement(Image, { src: icon, width: 48, height: 48, alt: label }),
                React.createElement("h2", { className: "mt-1 text-center font-bold leading-none" }, label)))));
}
var titleText = "Why are you shopping for insurance today?";
export default function UserIntentionRoute() {
    var push = useHistory().push;
    var dispatch = useAppDispatch();
    var _a = useAppSelector(function (state) { return ({
        insuranceProduct: state.applicant.insuranceProduct,
        commonAnalyticsProperties: state.analytics.commonAnalyticsProperties,
    }); }), insuranceProduct = _a.insuranceProduct, commonAnalyticsProperties = _a.commonAnalyticsProperties;
    var onClickInsuranceProduct = function (intentionKey) {
        selectedUserIntent(__assign(__assign({}, commonAnalyticsProperties), { shoppingIntentReason: intentionKey }));
        dispatch(selectUserIntent(intentionKey));
        var nextRoute = insuranceProduct === InsuranceProducts.Home
            ? PHASE.HOME_SELECT_ISSUER
            : PHASE.SELECT_AUTO_ISSUER;
        push(nextRoute);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement("div", { className: "grow overflow-y-scroll px-4 md:px-6 md:pt-4 desktop:pt-2" },
                React.createElement(RouteTitle, { variant: "small", className: "mb-4 font-bold md:mb-6" }, titleText),
                React.createElement("div", { className: "mb-4 grid grid-cols-2 gap-4 md:mb-6 md:gap-4" }, userIntentionOptions.map(function (_a) {
                    var key = _a.key, label = _a.label, icon = _a.icon;
                    return (React.createElement(IntentionOption, { key: key, label: label, icon: icon, onClick: function () { return onClickInsuranceProduct(key); } }));
                }))))));
}
